import { Box, IconButton } from '@mui/material';
import { VyIcon } from '@weft/icons';
import { CONTRACT_STATUSES } from '@weft/types';
import { isNullOrUndefined } from '@weft/utils';
import React from 'react';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import { Spinner } from '../../components/design/Spinner';
import { VyPageLayout } from '../../components/new-design/layout/VyPageLayout';
import { withGlobalSearchParams } from '../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../components/utility/SuspenseBoundary';
import { useContractPage } from '../../hooks/requests/pages/use-contract-page';
import { useContractId } from '../../hooks/use-contract-id';
import { ContractNavbar } from './contract-page-components/ContractNavbar';
import { ContractPageContent } from './contract-page-components/ContractPageContent';
import { ContractPageHeaderMenu } from './contract-page-components/ContractPageHeaderMenu/ContractPageHeaderMenu';
import { ContractPageTitle } from './contract-page-components/ContractPageTitle';

type ContractPageProps = {
  customerContractId?: string,
};

const ContractPage: React.FC<ContractPageProps> = ({ customerContractId }) => {
  const contractId = useContractId(customerContractId);
  const { data } = useContractPage(contractId);
 
  if (isNullOrUndefined(data)) {
    return <Spinner/>;
  }

  const { contractPageData: { contract } } = data;
  
  return (
    <>
      <Helmet>
        <title>{`Contract ${contract.customer.name} ${contract.plan.name}`}</title>
      </Helmet>

      <VyPageLayout
        path={['Plans', <NavLink to="/plans">Plans and Pricing</NavLink>, contract.plan.name]}
        title={( 
          <ContractPageTitle
            plan={contract.plan}
          />
        )}
        action={(
          <>
            <Box sx={{ padding: '20px' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '16px',
                  alignItems: 'center',
                }}
              > 
                <ContractNavbar
                  contractId={contract.id}
                  plan={contract.plan}
                  description={contract.plan.description}
                  contractEndDate={contract.endDate}
                  status={contract.status}
                />

                <ContractPageHeaderMenu
                  contractId={contractId}
                  planId={contract.plan.id}
                  planName={contract.plan.name}
                  billingData={contract.plan.billingData}
                  isActive={contract.status === CONTRACT_STATUSES.Active}
                  isTerminated={contract.status === CONTRACT_STATUSES.Terminated}
                  customerName={contract.customer.name}
                  contractStartDate={contract.startDate}
                  contractEndDate={contract.endDate}
                  contractName={contract.plan.name}
                  menuAnchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  menuTransformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  syncStatus={contract.syncStatus}
                >
                  <IconButton>
                    <VyIcon
                      icon="DotsMenu"
                    />
                  </IconButton>
                </ContractPageHeaderMenu>
              </Box>
            </Box>
          </>
        )}
      >
        <ContractPageContent customerContractId={customerContractId}/>
      </VyPageLayout>
    </>
  );
};

const ContractPageWithSuspenseBoundary = withSuspenseBoundary(withGlobalSearchParams(ContractPage));
export { ContractPageWithSuspenseBoundary as ContractPage };